// Keep existing staff profiles unless a replacement is supplied by the school.
const team = [
  {
    name: "Shazia Ahsan",
    role: "Principal",
    bio: "An experienced educator and attentive listener, Shazia leads through teamwork. She plans and supports her team’s work with a clear vision for the school.",
  },
  {
    name: "Amna Tabassum",
    role: "Principal · Khurrianwala Road",
    bio: "Amna has worked with students from kindergarten to Class 10 in a range of educational roles. She brings her experience in school leadership to The Arqam School’s Khurrianwala Road Campus.",
  },
  {
    name: "Ammara Shaheen",
    role: "Admin",
    bio: "Ammara joined The Arqam School in 2013 as a teacher. Her commitment and results led to a coordinator role, where she continued supporting the school’s teaching team.",
  },
  {
    name: "Areeba",
    role: "Assistant Admin",
    bio: "Areeba joined The Arqam School in 2024 as a coordinator and was promoted to Assistant Admin. She manages daily operations, maintains accurate records, and organizes schedules with honesty, efficiency, and a friendly approach.",
  },
  {
    name: "Sehar Arif",
    role: "Coordinator · Middle & High Girls Sections",
    bio: "Sehar joined The Arqam School in 2025 to coordinate the Middle and High Girls Sections. She supports academic achievement and leads professional development workshops to strengthen her colleagues’ teaching skills.",
  },
  {
    name: "Madiha",
    role: "Coordinator · Pre-Primary",
    bio: "Madiha joined The Arqam School in 2025 as the Pre-Primary Coordinator. She supports young children’s foundational learning and leads professional development workshops for fellow teachers.",
  },
  {
    name: "Eman Ashiq",
    role: "Coordinator · Pre-Primary",
    bio: "Eman joined The Arqam School as a teacher in 2022 and now serves as a Pre-Primary Coordinator. Her activity-based lessons, patience, and creative approach help young children learn in an engaging environment.",
  },
  {
    name: "Aqsa Shahzadi",
    role: "Coordinator · Primary",
    bio: "Aqsa joined The Arqam School as a teacher in 2024 and now coordinates the Primary Section. Her honesty, dedication, and consistent hard work support the school’s growth.",
  },
  {
    name: "Arshia Asghar",
    role: "Coordinator",
    bio: "Arshia has served as a coordinator at The Arqam School for three and a half years. She oversees academic planning, curricular activities, and school accounts. Through clear communication and accurate financial records, she helps maintain a disciplined, friendly learning environment.",
  },
  {
    name: "Mudasra Pervez",
    role: "Teacher",
    bio: "Mudasra has taught at The Arqam School for 13 years. Active in curricular and co-curricular activities, she works closely with colleagues and creates a positive, open learning environment. Her honesty and commitment have built strong relationships with students and staff.",
  },
];

export default team;
